/*
 * Copyright (c) 2024 NOOGA DEVELOPMENT, All rights reserved.
 * Author Julia Romanovskaya <julia.romanovskaya@noogadev.com>
 */

import { Epic, ofType } from 'redux-observable';
import { switchMap, map, catchError, takeUntil, exhaustMap, tap, mapTo } from 'rxjs/operators';
import { cashboxesClient } from '../../../api/cashBoxes/cashboxesClient';
import { from, of } from 'rxjs';
import {
    CashBoxStatusTabAction,
    CashBoxStatusTabActionType,
    fetchCashBoxStatusHistorySuccessAction,
    fetchCashBoxStatusHistoryErrorAction,
    downloadStatusHistorySuccessAction,
    downloadStatusHistoryErrorAction,
} from '../../../actions/CashBoxRegistry/Tabs/cashBoxStatusTabActions';
import { downloadDataAsFile, parseError } from '../../../../utils/utils';
import { i18n } from '../../../translation/i18n';
import { AxiosError } from 'axios';

export const fetchCashBoxStatusHistoryEpic: Epic<CashBoxStatusTabAction> = (action$) => {
    return action$.pipe(
        ofType(CashBoxStatusTabActionType.FETCH_CASHBOX_STATUS_HISTORY),
        switchMap((action) => {
            const { taxNumber, params } = action.payload;
            const listName = i18n.t('RegistryScreens.cashBoxStatusHistory').toLowerCase();

            return from(cashboxesClient.getCashBoxStatusesHistory(taxNumber, params)).pipe(
                map((resp) => {
                    return fetchCashBoxStatusHistorySuccessAction(resp);
                }),

                catchError((err: AxiosError) =>
                    of(
                        fetchCashBoxStatusHistoryErrorAction(
                            parseError(err, i18n.t('errors.failedLoadList', { listName })),
                        ),
                    ),
                ),

                takeUntil(action$.pipe(ofType(CashBoxStatusTabActionType.EXIT_CASHBOX_STATUS_TAB))),
            );
        }),
    );
};

export const cashBoxStatusHistoryDownloadEpic: Epic<CashBoxStatusTabAction> = (action$) => {
    return action$.pipe(
        ofType(CashBoxStatusTabActionType.DOWNLOAD_STATUS_HISTORY),
        exhaustMap((action) => {
            const taxNumber = action.payload;
            const fileName = `cashbox_${taxNumber}_StatusHistory.xls`;

            return from(cashboxesClient.downloadCashBoxStatusHistoryAsExcel(taxNumber)).pipe(
                tap((fileData) => downloadDataAsFile(fileName, fileData)),

                mapTo(downloadStatusHistorySuccessAction()),

                catchError((err: AxiosError) =>
                    of(
                        downloadStatusHistoryErrorAction(
                            parseError(err, i18n.t('errors.failedUploadFileName', { fileName })),
                        ),
                    ),
                ),
            );
        }),
    );
};
